// src/components/rewards/GiveChestButton.js
//
// Teacher button: "🎁 Give a chest" — a silver chest for every student
// passed in (on the teacher's roster). Once a day per class; the server
// (giveClassChest) checks the class and the day.
//
// Props: students [{ uid | id }], label

import React, { useState } from "react";
import { giveClassChest } from "../../services/rewardsService";
import "./rewards.css";

const GiveChestButton = ({ students = [], label }) => {
  const uids = students.map((s) => s.uid || s.id).filter(Boolean);
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  if (!uids.length) return null;
  const who = label || (uids.length === 1 ? "this student" : `all ${uids.length} students`);

  const give = async () => {
    if (!confirm) {
      setConfirm(true);
      return;
    }
    setConfirm(false);
    setBusy(true);
    setMsg(null);
    try {
      const out = await giveClassChest(uids);
      setMsg({ tone: "ok", text: `🎁 ${out.given} silver gift${out.given === 1 ? "" : "s"} sent!${out.notInClass?.length ? ` (${out.notInClass.length} not on your roster)` : ""}` });
    } catch (e) {
      setMsg({ tone: "bad", text: e?.message || "Couldn't send gifts just now." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="sbl-give-chest">
      <button type="button" className={`sbl-rw-chip is-chest ${confirm ? "is-confirm" : ""}`} onClick={give} disabled={busy}>
        {busy ? "Sending…" : confirm ? `Yes — a gift for ${who}` : `🎁 Give ${who} a gift`}
      </button>
      {confirm && (
        <button type="button" className="sbl-give-cancel" onClick={() => setConfirm(false)}>
          Cancel
        </button>
      )}
      <small>Once a day. Each gift has coins, stickers and maybe a power-up.</small>
      {msg && <p className={`sbl-rw-msg is-${msg.tone}`}>{msg.text}</p>}
    </div>
  );
};

export default GiveChestButton;
